import { FC } from 'react'
import { ArticleCategory, ArticleTag, Whitepaper } from 'src/api/types'
import { BreadCrumbs as BreadCrumbsProps } from 'src/types'
import BreadCrums from '@/components/Breadcrums'
import Article, { Props as ArticleDetailProps } from '@/components/Article'
import CardList from '@/components/module/CardList'
import SideList from '@/components/module/SideList'
import SideCard, { Props as SideCardProps } from '@/components/CardSide'
import WhitepaperCard, { Props as WhitepaperCardProps } from '@/components/WhitepaperCard'
import MainCard, { Props as MainCardProps } from '@/components/CardMain'
import MailMagazin from '@/components/MailMagazin'
import Category from '@/components/Category'
import SideBarDivider from '@/components/SideBarDivider'
import CVNavBox from '@/components/CVNavBox'
import Banner, { Props as BannerProps } from '@/components/Banner'
import SideTag from '@/components/SideTag'

export type Props = {
  article: ArticleDetailProps
  recommendedArticles: SideCardProps[]
  relatedArticles: MainCardProps[]
  relatedWhitepapers: WhitepaperCardProps[]
  breadcrumbs: BreadCrumbsProps
  categories: ArticleCategory[]
  banner: BannerProps
  tags: ArticleTag[]
}

const Container: FC<Props> = ({ article: a, relatedArticles: relAs, recommendedArticles: rAs, relatedWhitepapers: rWps, breadcrumbs, categories, banner, tags }) => {

  return (
    <main className="flex justify-center gap-5 flex-wrap">
      <div className="article-container">
        <div className="bg-white rounded-[4px] flex flex-col items-center px-6 md:px-[50px] py-5">
          <BreadCrums items={breadcrumbs} />
          <Article {...a} />
        </div>
        <div className="mt-4 flex flex-col items-center">
          <CVNavBox />
          <div className="card-container flex flex-col items-center">
            <SideBarDivider title="関連記事" fontSize="text-2xl" />
            <CardList>
              {relAs.map((a, idx) => {
                return (
                  <MainCard
                    key={`${a.title}-${idx}`}
                    {...a}
                  />
                )
              })}
            </CardList>
          </div>
        </div>
      </div>
      <div className="relative">
        <div className="sidebar xl:sticky xl:top-0">
          <div style={{ marginBottom: '20px' }}>
            <Banner {...banner} />
          </div>
          <MailMagazin />
          <SideBarDivider title="関連資料" />
          <SideList>
            {rWps.map((w, idx) => {
              return (
                <WhitepaperCard
                  key={`${w.title}-${idx}`}
                  {...w}
                />
              )
            })}
          </SideList>
          <SideBarDivider title="おすすめ記事" />
          <SideList>
            {rAs.map((a, idx) => {
              return (
                <SideCard
                  key={`${a.title}-${idx}`}
                  {...a}
                />
              )
            })}
          </SideList>
          <SideBarDivider title="カテゴリー" />
          <Category categories={categories} />
          {/* <Banner {...banner} /> */}
          <SideBarDivider title="キーワード" />
          <SideTag tags={tags} />
        </div>
      </div>
    </main>
  )
}

export default Container
